import { Box, Progress, Text, Image, Link } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { calculateDateRange, resetComments, resetSelectedCourse, selectedMenu, setHeaderText } from "../../redux/actions/actions";
import { loadCourseComments, loadSelectedCourse } from "../../redux/api_calls/apiCalls";
import { ReactComponent as Calendar } from '../../svg/calendar.svg'
import { ReactComponent as Certificate } from '../../svg/certificate.svg'
import { ReactComponent as PeopleEnrolled } from '../../svg/peopleEnrolled.svg'
import { ReactComponent as AverageTime } from '../../svg/clock.svg'
import { ReactComponent as Beginner } from '../../svg/beginner.svg'
import { ReactComponent as Intermediate } from '../../svg/intermediate.svg'
import { ReactComponent as Advanced } from '../../svg/advanced.svg'
import { ReactComponent as Comments } from '../../svg/comments.svg'

import TopicsList from "./TopicsList";


export default function CourseDetails(props) {
    const { selectedCourse, isLoading, selectedCourseError } = useSelector(state => state.selectedCourseState)
    const { comments } = useSelector(state => state.commentsState)
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const [commentsVisible, setCommentsVisible] = useState(false)

    const dispatch = useDispatch()
    console.log(selectedCourse)

    const getCourseFromParams = () => {
        dispatch(loadCourseComments(props.match.params.id))
        dispatch(loadSelectedCourse(props.match.params.id))
    }


    useEffect(() => {
        dispatch(setHeaderText('Courses'))
        dispatch(selectedMenu(1))
        getCourseFromParams()
        return () => {
            dispatch(resetSelectedCourse())
            dispatch(resetComments())
        }
        // eslint-disable-next-line
    }, [])

    const getIcon = (level) => {
        switch (level) {
            case 'Beginner':
                return <Beginner width='20px' height='20px' fill='#fa5953' />
            case 'Intermediate':
                return <Intermediate width='20px' height='20px' fill='#fa5953' />
            case 'Advanced':
                return <Advanced width='20px' height='20px' fill='#fa5953' />
            default:
                return
        }
    }

    const getRandomComment = () => {
        let randomNumber = Math.floor(Math.random() * comments.length)
        return `"${comments[randomNumber]["comment"]}" - ${comments[randomNumber].users.first_name} ${comments[randomNumber].users.last_name}`
    }


    return (
        <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >
            <Box width={['90%', '90%', '90%', '85%', '80%']} justifyContent='space-between' alignItems='flex-start' d='flex' flexDir='column'>
                {
                    isLoading && !selectedCourse ? <Progress size='xs' isIndeterminate width='100%' mt='3rem' /> :
                        <>

                            <Box width='100%' d='flex' justifyContent='space-between' alignItems='center'>
                                <Text
                                    fontSize={['20px', '25px', '30px', '35px', '40px']}
                                    d='flex'
                                    fontWeight='900'
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                    textTransform='capitalize'
                                    mb='1rem'
                                >
                                    {selectedCourse?.title}
                                </Text>
                                <Link href="#comments" style={{ textDecoration: 'none' }}>
                                    <Box d='flex' alignItems='center' justifyContent='center' cursor='pointer'>
                                        <Comments width='18px' height='18px' stroke="#999999" />
                                        <Text
                                            fontSize={['12px', '14px']}
                                            fontWeight='600'
                                            style={{ fontFamily: 'Mulish, sans-serif' }}
                                            color='#999999'
                                            ml='2'
                                        >
                                            Comments
                                        </Text>
                                    </Box>
                                </Link>
                            </Box>

                            <Box
                                width='100%'
                                justifyContent='space-between'
                                alignItems='flex-start'
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontSize={['14px', '14px', '14px', '15px', '16px']}
                                fontWeight='600'
                                d='flex'
                                mb='1rem'
                            >
                                <Box
                                    d='flex'
                                    justifyContent='space-between'
                                    alignItems='center'
                                    color='#666666'
                                    width='100%'
                                    flexWrap={['wrap', 'wrap', 'nowrap']}
                                    style={{ gap: '2rem' }}
                                >
                                    <Box d='flex' justifyContent='center' alignItems='center'>
                                        <Calendar />
                                        <Text ml='2'>{calculateDateRange(selectedCourse ? selectedCourse.start_date : '2021/08/15', selectedCourse ? selectedCourse.end_date : '2021/08/15')}</Text>
                                    </Box>
                                    <Box d='flex' justifyContent='center' alignItems='center'>
                                        <Certificate />
                                        <Text ml='2'>Certificate</Text>
                                    </Box>
                                    <Box d='flex' justifyContent='center' alignItems='center'>
                                        <PeopleEnrolled />
                                        <Text ml='2'>People Enrolled</Text>
                                    </Box>
                                    <Box d='flex' justifyContent='center' alignItems='center'>
                                        <AverageTime />
                                        <Text ml='2'>Average Time : 5 hours</Text>
                                    </Box>
                                    <Box d='flex' justifyContent='center' alignItems='center'>
                                        {getIcon(selectedCourse?.level)}
                                        <Text ml='2'>{selectedCourse?.level}</Text>
                                    </Box>
                                </Box>
                            </Box>

                            <Box width='100%' my='2rem' d='flex' flexDir={['column', 'column', 'column', 'row', 'row']} justifyContent='space-between'>
                                <Box
                                    width={['100%', '100%', '100%', '47.5%', '47.5%']}
                                    bg='#ffffff'
                                    height={['250px', '300px', '350px', '95%', '95%']}
                                    borderRadius='10px'
                                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                                    mb={['1rem', '1rem', '1rem', '1rem', null]}
                                >
                                    <Image
                                        src={selectedCourse?.cover_image_url}
                                        fallbackSrc="https://source.unsplash.com/random/800x600"
                                        objectFit='cover'
                                        borderRadius='10px'
                                        width='100%'
                                        height='100%'
                                    />
                                </Box>

                                <TopicsList
                                    topics={selectedCourse?.topics}
                                    courseId={props.match.params.id}
                                    completed={selectedCourse?.completed_topics}
                                    total={selectedCourse?.total_topics}
                                />
                            </Box>

                            <Text
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                fontSize='18px'
                                fontWeight='400'
                                color='#00000099'
                                lineHeight='32px'
                                my='1rem'
                            >
                                {selectedCourse?.description}
                            </Text>

                            <Box id="comments" d='flex' alignItems='center' mb='1rem'>
                                <Comments fill="#00000099" width='22px' height='22px' />
                                <Text
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                    fontSize='18px'
                                    fontWeight='400'
                                    color='#00000099'
                                    lineHeight='32px'
                                    ml='2'
                                    cursor='pointer'
                                    onClick={() => setCommentsVisible(!commentsVisible)}
                                >
                                    {comments.length} Comments {commentsVisible ? `(click to hide)` : `(click to expand)`}
                                </Text>

                            </Box>
                            <Box d={!commentsVisible ? 'flex' : 'none'} px='1.5rem' mb='2rem'>
                                <Text fontSize='14px' fontWeight='400' color='#999999'><em>{comments.length > 0 && `${getRandomComment()}`}</em></Text>
                            </Box>

                            <Box
                                d={commentsVisible ? 'flex' : 'none'}
                                w='47.5%'
                                flexDir='column'
                                bg='#ffffff'
                                borderRadius='10px'
                                boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                                mb='2rem'
                            >
                                <Box
                                    w='100%'
                                    h={commentsVisible ? 'fit-content' : '0px'}
                                    maxH='200px'
                                    transition='height 300ms linear'
                                    overflowY='auto'
                                    d={commentsVisible ? 'flex' : 'none'}

                                    flexDir='column'

                                    padding='20px'
                                    sx={{
                                        '&::-webkit-scrollbar': {
                                            width: '10px',
                                            borderRadius: '8px',
                                            backgroundColor: `transparent`,
                                            height: '90%',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            backgroundColor: `rgba(0, 0, 0, 0.2)`,
                                            borderRadius: '20px'
                                        },
                                    }}
                                >
                                    {
                                        comments.length > 0 ? comments.map((comment, idx) => <Box key={idx} position='relative' d='flex' w='100%' justifyContent='flex-start' alignItems='center' mb={idx !== comments.length - 1 && '2rem'} pb='1rem'>
                                            <Image width='45px' height='45px' objectFit='cover' borderRadius='50%' src={comment.users.avatar} fallbackSrc={"https://source.unsplash.com/random/800x600"} alt={comment.users.first_name} />
                                            <Box
                                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                                ml='1rem'
                                                d='flex'
                                                flexDir='column'
                                                justifyContent='center'
                                            >
                                                <Text fontSize='16px' mb='1' fontWeight='600' color='#00000099'>{comment.users.first_name} {comment.users.last_name}</Text>
                                                <Text fontSize='14px' fontWeight='400' color='#999999'><em>{comment.comment}</em></Text>
                                            </Box>
                                            <Box
                                                width='100%'
                                                height='1px'
                                                bg='rgba(0, 0, 0, 0.2)'
                                                position='absolute'
                                                bottom='0'
                                            ></Box>
                                        </Box>)
                                            :
                                            <Text fontSize='16px' mb='1' fontWeight='600' color='#00000099' textAlign='center'>No comments yet!</Text>
                                    }
                                </Box>
                            </Box>
                        </>
                }

                {
                    !isLoading && selectedCourseError && <Text>{selectedCourseError}</Text>
                }
            </Box>
        </Box>
    )
}